import { ChevronRight } from 'lucide-react';
import { SECONDARY_NAVIGATION, type ViewId } from '../components/layout/navigation';

type Props = {
  onNavigate: (viewId: ViewId) => void;
};

export const MoreView = ({ onNavigate }: Props) => (
  <div className="page-stack">
    <section className="intro-card">
      <p className="eyebrow">Planner collection</p>
      <h2>Everything else, close at hand</h2>
      <p>Open secondary tools without crowding the mobile navigation.</p>
    </section>
    <section className="more-grid" aria-label="More planner tools">
      {SECONDARY_NAVIGATION.map(({ description, icon: Icon, id, label }) => (
        <button type="button" className="more-card" key={id} onClick={() => onNavigate(id)}>
          <span className="more-card-icon" aria-hidden="true"><Icon size={22} /></span>
          <span><strong>{label}</strong><small>{description}</small></span>
          <ChevronRight size={18} aria-hidden="true" />
        </button>
      ))}
    </section>
  </div>
);
